import { useDashboard } from '../../dashboard/hooks/useDashboard';
import { formatStatValue } from '../../dashboard/utils/formatters';

export function RepresentativeMetricsSection() {
  const { data, isInitialLoading } = useDashboard();
  const stats = data?.stats ?? [];

  return (
    <section className="representative-profile-section" aria-labelledby="representative-metrics-title">
      <div className="representative-profile-section__heading">
        <h2 id="representative-metrics-title">نمای کلی</h2>
      </div>

      {isInitialLoading && stats.length === 0 ? (
        <div className="representative-profile-metrics" aria-label="در حال دریافت اطلاعات">
          <div className="representative-profile-skeleton" />
          <div className="representative-profile-skeleton" />
          <div className="representative-profile-skeleton" />
          <div className="representative-profile-skeleton" />
        </div>
      ) : stats.length > 0 ? (
        <div className="representative-profile-metrics">
          {stats.map((stat) => (
            <article key={stat.id} className="representative-profile-metric">
              <span className="representative-profile-metric__value">
                {formatStatValue(stat.value, stat.format)}
              </span>
              <span className="representative-profile-metric__label">{stat.label}</span>
              {stat.subtitle && (
                <span className="representative-profile-metric__subtitle">{stat.subtitle}</span>
              )}
            </article>
          ))}
        </div>
      ) : null}
    </section>
  );
}
